import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=dbb2da78&scoped=true&"
import script from "./MainContent.vue?vue&type=script&lang=js&"
export * from "./MainContent.vue?vue&type=script&lang=js&"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=dbb2da78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb2da78",
  null
  
)

export default component.exports